<template>
	<div class="photo-video-thumbnail" v-if="media.isPhoto || media.isVideo">
		<PlayIcon v-if="media.isVideo" type="solid" />
		<img v-if="media.isPhoto" :src="media.mediaUrl" class="ph-no-capture" />
		<img v-if="media.isVideo" :src="media.thumbnailUrl" class="ph-no-capture" />
	</div>
</template>

<script>
import { PlayIcon } from '@/icons'

export default {
	name: 'PhotoVideoThumbnail',
	components: { PlayIcon },
	props: {
		media: Object,
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

// Use font-size to manage width/height
.photo-video-thumbnail {
	@include flex;
	flex-shrink: 0;
	justify-content: center;
	border-radius: 3px;
	overflow: hidden;
	background: var(--neutral-400);
	position: relative;
	> img {
		width: 1em;
		height: 1em;
		object-fit: cover;
	}
	.pronto-icon {
		color: white;
		position: absolute;
		font-size: 0.45em;
	}
}
</style>
